import axios from 'axios';
import toCamelCase from '../utils/camelCase';
import { API_ENDPOINT_CHECK_NEARBY_STORES, recordApiResponse } from '../utils/newRelic';

export const getEarliestDelivery = (itemIds, zipCode) => {
  const url = `https://www.homedepot.com/mcc-cart/v3/appliance/deliveryAvailability/${itemIds}/zipCode/${zipCode}`;
  const promise = axios.get(url);

  return recordApiResponse(promise, API_ENDPOINT_CHECK_NEARBY_STORES, url).then((response) =>
    toCamelCase(response.data)
  );
};
